export class Search {
  /**
   * Normalize text for case-insensitive matching.
   */
  public normalize(str: unknown): string {
    return String(str ?? '').trim().toLowerCase();
  }

  /**
   * Returns true if the item contains the term in any of the specified fields.
   */
  public matchesTerm(item: any, term: string, fields: string[]): boolean {
    if (!term) return true; // when no term, treat as match (or change to false to hide)
    const nTerm = this.normalize(term);
    for (const f of fields) {
      const v = item?.[f];
      if (v == null) continue;

      // If field is number (e.g., postcode id), coerce to string
      const nValue = this.normalize(v);

      if (nValue.includes(nTerm)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Filter an array by multiple candidate fields (name, code, display_name, etc.).
   */
  public filterByFields<T extends Record<string, any>>(
    items: T[],
    term: string,
    fields: string[]
  ): T[] {
    if (!Array.isArray(items) || items.length === 0) return [];
    return items.filter((item) => this.matchesTerm(item, term, fields));
  }


  // Small helper to normalize strings for robust search
  public norm(s: string | null | undefined): string {
    return (s ?? '')
      .toString()
      .normalize('NFD')               // split accents
      .replace(/[\u0300-\u036f]/g, '')// remove diacritics
      .toLowerCase()
      .trim();
  }
}
